import { ErrorBoundary, PageContainer } from '@bbpos/ui';
import { useAuthStore } from '@/stores/use-auth-store';
import { ROLE_LEVELS } from '@/types/user';
import { TenantDashboardContent } from '@/components/features/dashboard/TenantDashboardContent';
import { PlatformDashboardContent } from '@/components/features/dashboard/platform/PlatformDashboardContent';
import { GstSetupBanner } from '@/components/features/settings/GstSetupBanner';
import { gstSetupWarning } from '@/lib/gst-setup';
import { useTaxRegime } from '@/hooks/use-tax-regime';

export function DashboardPage() {
  const profile = useAuthStore((state) => state.profile);
  const user = useAuthStore((state) => state.user);
  const roleLevel = ROLE_LEVELS[user?.role ?? ''] ?? 0;
  const isPlatformRole = roleLevel >= ROLE_LEVELS.MODERATOR;
  const isIndia = useTaxRegime().regime === 'GST_INDIA';

  if (isPlatformRole) {
    return (
      <PageContainer
        title="Dashboard"
        subtitle="Platform admin workspace"
        breadcrumbs={[{ label: 'Home' }]}
        variant="fluid"
      >
        <ErrorBoundary resetKey="platform-dashboard">
          <PlatformDashboardContent />
        </ErrorBoundary>
      </PageContainer>
    );
  }

  return (
    <PageContainer
      title="Dashboard"
      subtitle={profile?.tenant?.business_name}
      breadcrumbs={[{ label: 'Home' }]}
    >
      {/* "Set your GSTIN / state" (gst-parked task 030) — India GST only. */}
      <GstSetupBanner
        warning={
          profile?.tenant
            ? gstSetupWarning({
                isIndia,
                setting: profile.tenant.gst_registered_setting,
                gstin: profile.tenant.gstin,
                state: profile.tenant.state,
                locations: profile.locations ?? [],
              })
            : null
        }
        canFix={roleLevel >= ROLE_LEVELS.OWNER}
      />
      <ErrorBoundary resetKey={profile?.tenant?.id}>
        <TenantDashboardContent />
      </ErrorBoundary>
    </PageContainer>
  );
}
